const emailRule = [
  v => {
    return !!v || "E-Mail is required";
  },
  v => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v) ||
    "E-Mail must be valid"
];

const requiredRule = [v => !!v || "required"];

export { emailRule, requiredRule };
